/* SigueArmando · "Inicio que se ilumina": el patio se enciende al llegar y la penumbra se levanta al bajar */
(function () {
  var root = document.querySelector('[data-sa-ini]');
  if (!root) return;
  var dim = document.querySelector('[data-sa-dim]');
  var bulbs = Array.prototype.slice.call(root.querySelectorAll('.sa-ini__bulb'));
  /* Si el computador tiene las animaciones desactivadas (muy común en Windows),
     no hacemos movimientos, pero el oscurecer/iluminar con el scroll se mantiene. */
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 0) con foto de fondo: el patio se "enciende" apenas carga la imagen */
  var bgImg = root.querySelector('.sa-ini__bg img');
  var lightUp = function () { requestAnimationFrame(function () { root.classList.add('is-lit'); }); };
  if (bgImg && !reduce) {
    if (bgImg.complete) setTimeout(lightUp, 200); else { bgImg.addEventListener('load', lightUp); setTimeout(lightUp, 2500); }
  } else {
    root.classList.add('is-lit');
  }

  /* 1) guirnalda dibujada (solo sin foto): las ampolletas se encienden una a una */
  if (reduce) bulbs.forEach(function (b) { b.classList.add('is-on'); });
  else setTimeout(function () {
    bulbs.forEach(function (b, i) { setTimeout(function () { b.classList.add('is-on'); }, i * 160); });
  }, 450);

  /* 2) al bajar, la penumbra del resto de la página se levanta.
     Se mide la posición del inicio en pantalla, así funciona con cualquier tipo de scroll
     (rueda del mouse, trackpad, teclado o pantalla táctil). */
  var ticking = false;
  function paint() {
    ticking = false;
    var r = root.getBoundingClientRect();
    var run = Math.max(1, r.height * 0.7);
    var p = Math.max(0, Math.min(1, -r.top / run));
    root.style.setProperty('--p', (0.35 + p * 0.65).toFixed(3));
    root.style.setProperty('--s', p.toFixed(3));
    if (dim) dim.style.setProperty('--p', p.toFixed(3));
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }

  if (dim) dim.classList.add('is-on');
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('wheel', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  paint();
})();
